var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zas\xF3b 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,58H36a1,1,0,0,1,0-2H51A27,27,0,0,0,51,2H31a1,1,0,0,1,0-2H51a29,29,0,0,1,0,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,54A25,25,0,1,1,76,29,25,25,0,0,1,51,54ZM51,6A23,23,0,1,0,74,29,23,23,0,0,0,51,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,30H1a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,15H14a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,58H26a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,2H23a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,2H8A1,1,0,0,1,8,0H19a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,48H16a1,1,0,0,1,0-2H29a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,48H8a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50,
    y: 45,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 59,
    y: 42.59,
    width: 2,
    height: 4,
    transform: "translate(-14.26 35.97) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41,
    y: 11.41,
    width: 2,
    height: 4,
    transform: "translate(-1.08 22.8) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.59,
    y: 36,
    width: 2,
    height: 4,
    transform: "translate(0.39 76.66) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.41,
    y: 18,
    width: 2,
    height: 4,
    transform: "translate(0.38 40.67) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 67,
    y: 28,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31,
    y: 28,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.59,
    y: 19,
    width: 4,
    height: 2,
    transform: "translate(-1.08 35.97) rotate(-29.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.41,
    y: 37,
    width: 4,
    height: 2,
    transform: "translate(-14.26 22.79) rotate(-29.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58,
    y: 12.41,
    width: 4,
    height: 2,
    transform: "translate(18.39 58.67) rotate(-60.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 43.59,
    width: 4,
    height: 2,
    transform: "translate(-17.61 58.68) rotate(-60.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,19a3,3,0,0,1,1,.18V9a1,1,0,0,0-2,0V19.18A3,3,0,0,1,51,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,30a1,1,0,0,1-1-1V22a1,1,0,0,1,2,0v7A1,1,0,0,1,51,30Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastIco);
export default __webpack_public_path__ + "static/media/fast-ico.096176083f451e3c2c308a98d7265dd4.svg";
export { ForwardRef as ReactComponent };